/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { TextField, Button, Stack, Typography } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";

import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { LoginStep } from "./Login";
// import { showSecuredEmail } from "./DirectLogin";

interface AuthCodeProps {
  setLoginStep: (step: LoginStep) => void;
  goToForgetPass: () => void;
  onSubmit: (code: string) => Promise<void>;
  emailAddress?: string;
}

const schema = yup.object().shape({
  verification_code: yup.string().required()
});

export const AuthCode: React.FC<AuthCodeProps> = ({ setLoginStep, goToForgetPass, onSubmit }) => {
  const { values, handleChange, isValid, handleSubmit, errors } = useFormik({
    validationSchema: schema,
    initialValues: { verification_code: "" },
    onSubmit: (values) => onSubmit(values.verification_code)
  });

  return (
    <Stack alignItems="stretch" gap="50px">
      <Typography
        sx={{
          color: "#173c4c",
          fontFamily: "Oswald, sans-serif",
          fontSize: "2.5rem",
          fontWeight: 300,
          letterSpacing: "1.25px",
          lineHeight: "60px"
        }}
      >
        Two-Factor Authentication Required
      </Typography>
      <form onSubmit={handleSubmit}>
        <Stack alignItems="stretch" gap="20px" maxWidth="300px">
          <Typography
            sx={{
              color: "#173c4c",
              textAlign: "center"
            }}
          >
            We`ve sent an SMS message to the phone number associated with your account, please type bellow the code
            you`ve received in the SMS message to complete your login
          </Typography>
          <TextField
            label="Code"
            name="verification_code"
            placeholder="code"
            value={values.verification_code}
            autoFocus
            InputLabelProps={{ shrink: true }}
            error={!!errors?.verification_code}
            helperText={errors?.verification_code}
            onChange={handleChange}
          />
          <Button
            disabled={!isValid || !values.verification_code}
            variant="contained"
            type="submit"
            sx={{
              borderRadius: "5px",
              textTransform: "none"
            }}
          >
            Complete login
          </Button>
          <Typography onClick={goToForgetPass} sx={{ fontSize: "0.8rem", textAlign: "center", color: "#173c4c" }}>
            Forgot your password?
          </Typography>

          <Stack
            direction="row"
            sx={{ gap: "8px", justifyContent: "center", cursor: "pointer" }}
            onClick={() => setLoginStep("default")}
          >
            <ArrowCircleDownIcon sx={{ transform: "rotate(90deg)" }} />
            <Typography sx={{ color: "#173c4c" }}>Go back to main login</Typography>
          </Stack>
        </Stack>
      </form>
    </Stack>
  );
};
